import React from "react";
import { motion } from "framer-motion";
import { CircuitBackground, Particles } from "./fx/Backgrounds";

export const PageHero = ({ label, title, desc, image }) => (
  <section className="relative flex min-h-[62vh] items-end overflow-hidden pb-16 pt-32">
    {image && (
      <>
        <img src={image} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/80 via-ink/85 to-ink" />
      </>
    )}
    <div className="absolute inset-0 bg-[radial-gradient(circle_at_75%_20%,rgba(33,90,165,0.3),transparent_55%)]" />
    <div className="absolute inset-0 grid-bg opacity-30" />
    <CircuitBackground className="opacity-60" />
    <Particles count={18} />
    <div className="container-pdr relative z-10">
      {label && (
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} className="mb-5 inline-flex items-center gap-2">
          <span className="h-px w-8 bg-glow-2/70" />
          <span className="mono-label">{label}</span>
        </motion.div>
      )}
      <motion.h1
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-4xl font-display text-4xl font-extrabold leading-[1.05] sm:text-5xl lg:text-6xl"
      >
        {title}
      </motion.h1>
      {desc && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.15, duration: 0.7 }}
          className="mt-6 max-w-2xl text-base leading-relaxed text-white/65 md:text-lg"
        >
          {desc}
        </motion.p>
      )}
    </div>
  </section>
);
